import { jsx as _jsx } from "react/jsx-runtime";
import { useTabHandler } from '../../../hooks/useTabHandler';
import { VideoTab } from './tabs/VideoTab/video';
import { VideoLabTab } from './tabs/VideoLabTab/VideoLab';
import { VideoMediaLabTab } from './tabs/VideoMediaLab/VideoMediaLab';
import { LNHPushNotificationTestOnly } from './tabs/MessagingTab/LNHPushNotification';
export const Slot6 = ({}) => {
    const tabsToDisplay = {
        VideoLab: (value) => _jsx(VideoLabTab, {}),
        VideoMediaLab: (value) => _jsx(VideoMediaLabTab, {}),
        Video: (value) => _jsx(VideoTab, {}),
        PushNotifications: () => _jsx(LNHPushNotificationTestOnly, {})
    };
    const { tabs } = useTabHandler(tabsToDisplay, true, 0);
    return (_jsx("div", { children: tabs }));
};
